var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpWhitelisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3754 2.72202L5.37762 4.94328C3.932 5.58578 2.97801 7.02462 3.07 8.60391C3.42963 14.7781 5.23768 17.4963 9.9358 20.677C11.1804 21.5196 12.821 21.5216 14.0646 20.6777C18.7772 17.4797 20.5206 14.7231 20.9118 8.6253C21.0138 7.03557 20.0583 5.58145 18.6026 4.93447L13.6246 2.72202C12.5903 2.26235 11.4097 2.26235 10.3754 2.72202Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12L10.7528 13.4023C11.1707 13.7366 11.7777 13.6826 12.1301 13.2799L15 10",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpWhitelisting);
export default __webpack_public_path__ + "static/media/ip-whitelisting.75189a776dba9ee0c8e1318c841ba95a.svg";
export { ForwardRef as ReactComponent };